
// localstorage | sessionstorage key name
export const ACCESS_TOKEN_KEY = "accessToken";
export const REFRESH_TOKEN_KEY = "refreshToken";
export const DARK_MODE_KEY = "darkMode";
export const USER_DETAILS_KEY = "user";

// DEFAULT MESSAGES
export const DEFAULT_ERROR_MSG = "Something went wrong!";
